module.exports = __webpack_public_path__ + "3875877514df7f2d3dbe0d92c5a6f36e.svg";